import React, { useState } from 'react';// Import Link icon
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, ChevronDown, Info, Settings, Link, MoreVertical, ChevronRight } from 'lucide-react'
import '../shared/AccordianStyle.css';
import { motion, AnimatePresence } from 'framer-motion';
import { CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from "@coreui/react";
import InfoModel from './InfoModel';
import Media from './Media';
const AccordianEditDelete = ({ title, content, editAccordion, accordion, deleteAccordion, design = false, isFirst = false, handleAddTitleDescription, setActiveDescriptions, setParentAccordions, parentId, file, setFile, handleTitleFileSave, type, attachedType, handleTitleParentMediaId, index = 0, showTab, ApiCallingType, differentModuleCopyFunctionality, handelSubmit, onHeaderClick, isSelected = false, isViewOnly = false, showEducationButton = false }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [infoModelVisible, setInfoModelVisible] = useState(false);
    const [showMediaModel, setShowMediaModel] = useState(false)
    const hasFiles = (value) => Array.isArray(value) ? value.length > 0 : value && (typeof value !== 'object' || Object.values(value).some(hasFiles))

    const [highlightedIndex, setHighlightedIndex] = useState(null);
    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };
    const handleHeaderClick = () => {
        toggleAccordion();
        if (typeof onHeaderClick === 'function') {
            onHeaderClick(accordion);
        }
    };
    const handleConvertAndOpenMedia = () => {
        if (accordion?.attached) {
            const convertedData = Object.entries(accordion.attached)
                .flatMap(([type, files]) =>
                    files.map(file => ({
                        url: typeof file === "object" ? file.url : file,
                        publicId : file?.publicId,
                        id : file?.id,
                        type,
                        fileName: typeof file === "object" ? file.fileName || "" : file.split('/').pop()
                    }))
                );

            setFile(convertedData);
        } else {
            setFile([]);
        }

    };






    return (
        <div className={`accordion-item w-full accordion-scope accordion-edit-delete-theme assessment-plan-suggestion-theme accordion-edit-delete-theme__trigger ${isSelected ? 'accordion-theme--selected' : ''} ${isOpen ? 'accordion-item--expanded' : ''}`} style={{ minWidth: design ? '' : '500px', marginTop: title ? '10px' : '0', overflow: isOpen ? 'visible' : undefined }}  >
            {title && <h2 className="accordion-header">
                <button
                    className={`accordion-button ${!isOpen ? 'collapsed' : ''} d-flex justify-content-between align-items-center border accordion-edit-delete-theme__trigger`}
                    type="button"
                    onClick={handleHeaderClick}

                >
                    <div className='d-flex align-items-center gap-2' >
                        <div>{title}</div>
                        <div className='d-flex align-items-center m-1' style={{ gap: '4px' }}>
                            {handleAddTitleDescription && setActiveDescriptions && (
                                <div>
                                    <Info
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleAddTitleDescription(accordion, e);
                                            setActiveDescriptions("title");
                                            setHighlightedIndex(index);
                                            setTimeout(() => setHighlightedIndex(null), 2000);
                                        }}
                                        className={`accordion-edit-delete-theme__icon ${highlightedIndex === index ? "highlighted" : ""}`}
                                        strokeWidth={1.5}
                                        size={22}
                                        style={{
                                            transition: "all 0.3s ease-in-out",
                                            color: highlightedIndex === index ? "#0d6efd" : "",
                                            backgroundColor: highlightedIndex === index ? "rgba(13, 110, 253, 0.2)" : "",
                                            borderRadius: "50%",
                                            width: "22px",
                                            height: "22px"
                                        }}
                                    />
                                </div>
                            )}

                            {(showEducationButton || Boolean(hasFiles(accordion?.attached) || hasFiles(accordion?.education))) && (
                                <div>
                                    <div title="Add/Edit Education" onClick={(e) => { e.stopPropagation(); handleTitleParentMediaId(parentId); handleConvertAndOpenMedia(); setShowMediaModel(true) }} className="d-flex justify-content-center align-items-center accordion-edit-delete-theme__media-trigger pe-accordion-badge" style={{ width: "22px", height: "22px", fontSize: "12px", border: "1.5px solid var(--ui-text-primary, #ffffff)", borderRadius: '100px', color: 'var(--ui-text-primary, #ffffff)' }}>
                                        e
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <span className="custom-icon ms-auto d-flex gap-1 align-items-center justify-content-center accordion-edit-delete-theme__icon-group">

                            {editAccordion && <Pencil size={16} className=" " onClick={() => editAccordion(accordion.id, accordion.title, accordion.code)} />}
                            {deleteAccordion && <Trash2 size={20} strokeWidth={1.5} onClick={() => { deleteAccordion(accordion.id) }} />}
                            <ChevronRight size={25} strokeWidth={1.5} onClick={toggleAccordion} style={{ transform: `${isOpen ? "rotate(270deg)" : "rotate(90deg)"}`, transition: "transform 0.3s ease-in-out" }} />

                        </span>
                    </div>

                </button>
            </h2>}
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.div
                        className="accordion-collapse"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                        style={{ border: 'none', overflow: isOpen ? 'visible' : 'hidden', borderBottomLeftRadius: 'var(--ui-radius-md, 8px)', borderBottomRightRadius: 'var(--ui-radius-md, 8px)' }}
                    >
                        <div className="accordion-body accordion-edit-delete-theme__body">
                            {content}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>

            {showMediaModel && <div> <Media showMediaModel={showMediaModel} setShowMediaModel={setShowMediaModel} setParentAccordions={setParentAccordions} parentId={parentId} file={file} setFile={setFile} handleFileSave={handleTitleFileSave} type={type} attachedType={attachedType} showTab={showTab} ApiCallingType={ApiCallingType} differentModuleCopyFunctionality={differentModuleCopyFunctionality} handelSubmit={handelSubmit} isViewOnly={isViewOnly} /></div>}
        </div>
    );
};

export default AccordianEditDelete;
